export default __webpack_public_path__ + "static/media/reward1_detail_4.0025c56b.png";